// extracted by mini-css-extract-plugin
export default {"map":"CoordinatesMap_map__QpGGw"};